import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSEnterPhoneData, type EnrollmentHYCSEnterPhoneSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSEnterPhoneDataMock: EnrollmentHYCSEnterPhoneData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/enter-phone',
}

export const submitEnrollmentHYCSEnterPhoneDataMock: EnrollmentHYCSEnterPhoneSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-phone',
}

export const mockGetEnrollmentHYCSEnterPhoneData = graphql.mutation('getEnrollmentHYCSEnterPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSEnterPhoneDataMock } })
})

export const mockSubmitEnrollmentHYCSEnterPhoneData = graphql.mutation('submitEnrollmentHYCSEnterPhoneData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSEnterPhoneDataMock } })
})

export const mockEnrollmentHYCSEnterPhone = [
  mockGetEnrollmentHYCSEnterPhoneData,
  mockSubmitEnrollmentHYCSEnterPhoneData,
]
